<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 8.66699C9.10457 8.66699 10 7.77156 10 6.66699C10 5.56242 9.10457 4.66699 8 4.66699C6.89543 4.66699 6 5.56242 6 6.66699C6 7.77156 6.89543 8.66699 8 8.66699Z"
      stroke="#F57E53"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.00032 1.33301C6.58584 1.33301 5.22928 1.89491 4.22909 2.89511C3.2289 3.8953 2.66699 5.25185 2.66699 6.66634C2.66699 7.92767 2.93499 8.75301 3.66699 9.66634L8.00032 14.6663L12.3337 9.66634C13.0657 8.75301 13.3337 7.92767 13.3337 6.66634C13.3337 5.25185 12.7718 3.8953 11.7716 2.89511C10.7714 1.89491 9.41481 1.33301 8.00032 1.33301Z"
      stroke="#F57E53"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
